import { render, staticRenderFns } from "./BimaBambaBenefits.vue?vue&type=template&id=54deacd1"
import script from "./BimaBambaBenefits.vue?vue&type=script&lang=js"
export * from "./BimaBambaBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports